export function parseSlug(slug: string) {
  const artworksSlugParams = ['artists', 'medium', 'styles', 'countries'];

  const result: Record<string, string> = {};

  if (!slug) {
    return result;
  }

  const parts = slug.split('/');
  for (const part of parts) {
    const [type, ...value] = part.split('-');

    if (type) {
      result[artworksSlugParams.includes(type) ? `${type}_slugs` : type] = value.join('-').replaceAll('+', ',');
    }
  }

  return result;
}
